<template>
    <simple-layout
        class="kpi-page"
        :indicators="indicators"
        :modelsLoaded="true"
    >
        <div class="numbers-section">
            <h5>Pour toute la plateforme</h5>
            <el-row :gutter="0" class="data-line">
                <el-col :span="10" :offset="2">
                    <div>Nombre de clients total: <span class="value">{{ kpi[0].values.total_clients }}</span></div>
                </el-col>
                <el-col :span="10" :offset="2">
                    <div>Nombre de véhicules total: <span class="value">{{ kpi[0].values.total_vehicles }}</span></div>
                </el-col>
            </el-row>
            <el-row :gutter="0" class="data-line">
                <el-col :span="10" :offset="2">
                    <div>Nombre d'exécutants: <span class="value">{{ kpi[0].values.total_executants }}</span></div>
                </el-col>
                <el-col :span="10" :offset="2">
                    <div>Nombre de requêtes d'inspections total: <span class="value">{{ kpi[0].values.total_inspection_requests }}</span></div>
                </el-col>
            </el-row>
        </div>
        <div class="svg-title">Nombre de requêtes d'inspections par mois</div>
        <div v-show="showValue" class="month-value">Nombre de requêtes d'inspections sur le mois survolé: {{tooltipValue}}</div>
        <div class="svg" ref="svg"></div>
    </simple-layout>
</template>

<script>

import {mapGetters} from 'vuex';
import * as d3 from 'd3';

export default {

    components: {

    },

    props: {

    },

    data: function(){
        return {
            tooltipValue: '',
            showValue: false
        };
    },

    computed: {
        ...mapGetters([
            'kpi',
            'bases',
            'groups',
        ]),

        indicators(){
            return [
                {
                    title: this.groups.length,
                    subtitle: 'bases',
                },
                {
                    title: this.bases.length,
                    subtitle: 'flottes',
                }
            ]
        },
    },

    mounted: function(){
        let updateDateFormat = (raw) =>{
            return raw.split('-').reverse().join('/')
        }
        let data = Object.keys(this.kpi[0].values.graph).map(key => {
            return {
                name: updateDateFormat(key),
                value: this.kpi[0].values.graph[key]
            };
        });
        let margin = {top: 20, right: 0, bottom: 30, left: 40};
        let height = 500;
        let width = 800;
        let y = d3.scaleLinear()
            .domain([0, d3.max(data, d => {
                return d.value;
            })]).nice()
            .range([height - margin.bottom, margin.top]);

        let x = d3.scaleBand()
            .domain(data.map(d => d.name))
            .range([margin.left, width - margin.right])
            .padding(0.1);

        const yAxis = g => g
            .attr('transform', `translate(${margin.left},0)`)
            .call(d3.axisLeft(y))
            .call(g => g.select('.domain').remove());
        const xAxis = g => g
            .attr('transform', `translate(0,${height - margin.bottom})`)
            .call(d3.axisBottom(x).tickSizeOuter(0));

        const svg = d3.create('svg').attr('viewBox', [0, 0, width, height]);
        svg.append('g')
            .attr('class', 'bars')
            .attr('fill', 'steelblue')
            .selectAll('rect')
            .data(data)
            .join('rect')
            .attr('x', d => {
                return x(d.name);
            })
            .attr('y', d => {
                return y(d.value);
            })
            .attr('height', d => {
                return y(0) - y(d.value);
            })
            .attr('width', x.bandwidth())
            .on('mouseover', d => {
                this.showValue = true;
                this.tooltipValue = d.value;
            })
            .on('mouseout', () => {
                this.showValue = false;
            });

        svg.append('g')
            .attr('class', 'x-axis')
            .call(xAxis);

        svg.append('g')
            .attr('class', 'y-axis')
            .call(yAxis);

        this.$refs.svg.appendChild(svg.node());
    },

    methods: {
    }
};
</script>

<style lang="scss">
.kpi-page {
    position: relative;
    .numbers-section {
        margin: 40px 0;
        .data-line {
            font-size: 18px;
            margin-bottom: 20px;
            .value {
                padding-left: 10px;
                font-size: 30px;
            }
        }
    }
    .svg-title {
        font-size: 26px;
        padding-left: 5%;
        margin-bottom: 40px;
    }
    .svg {
        width: 80%;
        margin: 0 auto;
    }
    .month-value {
        position: absolute;
        top: 380px;
        left: 10%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Kpi/Index.vue